import { AddressDB } from '../../user-management/models/address'
import { BeneficiaryInfo, OtherDrugCoverage } from './enrollments'
import { PaymentAccount } from '../models/payment-account'
import { CurrentUser } from '../../common/models/current-user'
import { RaceData } from '../models/race-data'
import { EthnicityData } from './ethnicity-data'

export class EnrollmentViewModel {
    ACCHOLDERNAME: string = ''
    ACCOUNTNB: string = ''
    AGENTEMAIL: string = ''
    AGENTFN: string = ''
    AGENTID: string = ''
    AGENTLN: string = ''
    APPADD1: string = ''
    APPADD2: string = ''
    APPCITY: string = ''
    APPDOB: Date | null
    APPDT: Date | null
    APPEMAIL: string = ''
    APPFN: string = ''
    APPGEN: string = ''
    APPLN: string = ''
    APPMI: string = ''
    APPST: string = ''
    APPZIP: string = ''
    ATESTPROOF: string = ''
    AUTHREPADD1: string = ''
    AUTHREPADD2: string = ''
    AUTHREPCITY: string = ''
    AUTHREPIND: string = ''
    AUTHREPNAME: string = ''
    AUTHREPPHONE: string = ''
    AUTHREPREL: string = ''
    AUTHREPST: string = ''
    AUTHREPZIP: string = ''
    APPPHONE: string = ''
    CELLPHONE: string = ''
    COBBIN: string = ''
    COBEFFDT: Date | null | undefined
    COBPCN: string = ''
    COBTERMDT: Date | null | undefined
    COMPLETEIND: boolean
    CONF: string = ''
    CONTRACT: string = ''
    CUID: string = ''
    CULTURE: string = ''
    EFFDT: Date | null
    EFTTYPE: string | null = ''
    ELECTION: string = ''
    FININSTNAME: string = ''
    HICN: string = ''
    LANG: string = ''
    LEGREPEMAIL: string = ''
    LTCFACILITY: string = ''
    LTCPHONE: string = ''
    LTCADD1: string = ''
    MAILADD1: string = ''
    MAILADD2: string = ''
    MAILCITY: string = ''
    MAILST: string = ''
    MAILZIP: string = ''
    MEDA: Date | null
    MEDB: Date | null
    NOTES: string = ''
    OTHCVRG: string = ''
    OTHCVRGGRP: string = ''
    OTHCVRGID: string = ''
    OTHCVRGNAME: string = ''
    PLANNAME: string = ''
    PLANST: string = ''
    PLANTYPE: string = ''
    PLANYEAR: string = ''
    POA: string = ''
    PWO: string = ''
    ROUTINGNB: string = ''
    SEPEFFDT: Date | null
    SEPREASONCD: number = -1
    SEPREASONTEXT: string = ''
    SOA: string = ''
    SUFFIX: string = ''
    TITLE: string = ''
    DEX: string = ''
    AGENTDEX: string = ''
    APPSIGNEDIND: boolean
    AUTHREPSIGNEDIND: boolean
    SUBMISSIONTYPECODE: string
    ADMINID: number
    ENROLLKEY: string
    AGENTNAME: string
    USERNAME: string
    EOB: string
    AgentSignature: string
    UNIQUELINK: string
    // seeting radio button value in phone enrollment
    RBLRECORD: string
    RBLREP: string
    RBLBENFE: string
    RBLBENFEREPLY: string
    DATEOFRECEIPT: Date
    RBLHEALTHCOVERAGE: string
    RBLHMO: string
    RBLBENEFICIARYPART: string
    RBLLONGTERM: string
    RBLGRP: string
    RBLSAMESTATE: string
    RBLVALIDPERIOD: string
    ISSAMEADDRESS: boolean
    RBLLIS: string
    RBLAGREEMENT: string
    RBLVALIDINFO: string
    AUTHREPEMAIL: string
    AUTHREPCOPYIND: string
    AppStatus: string
    ISSINGLEGROUP: boolean
    STEPCODE: string
    AGENTORGID: number
    paymentOption: string
    POBOX: boolean
    POVERIND: string

    POBERIND: string
    BENEFICIARYSIGN: string
    BENEFICIARYDATE: string
    BGCHECK: boolean
    LANGFORMAT: string
    ENROLLEEWORKSTATUS: string
    SPOUSEWORKSTATUS: string
    IsBeneficiary: string
    INSURANCECOMPID: number
    USERPROFILEID: number
    CALLOGID: number
    CALLENROLLMENTSTARTTIME: string
    PLANTYPENAME: string
    AGENTDETAILS: CurrentUser
    TYPEID: number
    SELAPPOINTMENTREP: string
    ISDISABLED: boolean
    CC: string
    UNMTHS: string
    SECMBRID: string
    RELCD: string
    FAMILYID: string
    PERSONCD: string
    ISEXTERNALAGENT: boolean
    CARRIER: string
    ACCOUNT: string
    GROUP: string
    STCOBGROUPNAME: string
    ELECTIONTYPEID: string
    ENROLLMENTID: string
    ACCESSKEY: string
    SINGLEGRPNAME: string
    SAMEADDRESS: boolean
    ISSTCOB: boolean
    CHANNELID: string
    STEEREDIND: boolean
    FORMNAME: string
    historyStatus: string
    RELTEXT: string
    PERSONTEXT: string
    EMERNAME: string
    EMERPHONE: string
    EMERREL: string
    EMERIND: string
    ISBACK: boolean
    CAREFAC: string
    PRIORID:string

    //NEJE Fields just to capture yes/no
    PartAInd: string
    PartBInd: string
    y1: string
    y2: string
    y3: string
    y4: string
    y5: string
    y6: string
    y7: string
    y8: string

    authcomplete: string
    enrolleeaware: string
    hmoppo: string
    unionrbl: string
    annualAep: string
    AuthOrEnrollee: string
    OldAppDT: Date

    //STCOB Fields
    SECGROUP: string
    SECCARRIER: string
    SECACCOUNT: string
    EXTERNALID: string
    CAREQUAL: string

    // Race and Ethnicity
    selecteRace: RaceData[]
    selectedEthnicity: EthnicityData[]
    displayRace: string
    displayEthnicity: string
    Race: string
    Ethnicity: string
    isPhoneEnrollment: boolean

    // Accessibility
    accessibility: string

    //Gender
    GENDERNPRONOUNOTH: string = ''
    CURRENTGENDEROTH: string = ''
    displayGenderProNoun: string = ''
    GENDERNPRONOUN: string = ''
    CURRENTGENDER: string = ''
    displayCurrentGender: string = ''

    //Relationship to Enrollee
    INDREPNAME: string = ''
    RELTOENROLL: string = ''
    NPN: string = ''
    INDREPIND: string = ''
    displayRELTOENROLL: string = ''

    set residentialAddress(address: AddressDB) {
        this.APPADD1 = address.addressLine1
        this.APPADD2 = address.addressLine2
        this.APPCITY = address.city
        this.APPST = address.state
        this.APPZIP = address.zip
        this.SAMEADDRESS = address.sameAddress
    }
    get residentialAddress(): AddressDB {
        return {
            addressLine1: this.APPADD1,
            addressLine2: this.APPADD2,
            city: this.APPCITY,
            state: this.APPST,
            zip: this.APPZIP,
            sameAddress: this.SAMEADDRESS
        } as AddressDB
    }

    set mailingAddress(address: AddressDB) {
        this.MAILADD1 = address.addressLine1
        this.MAILADD2 = address.addressLine2
        this.MAILCITY = address.city
        this.MAILST = address.state
        this.MAILZIP = address.zip
    }
    get mailingAddress(): AddressDB {
        return {
            addressLine1: this.MAILADD1,
            addressLine2: this.MAILADD2,
            city: this.MAILCITY,
            state: this.MAILST,
            zip: this.MAILZIP
        } as AddressDB
    }

    set beneficiaryInfo(beneficiaryInfo: BeneficiaryInfo) {
        this.APPLN = beneficiaryInfo.lastName
        this.APPFN = beneficiaryInfo.firstName
        this.APPMI = beneficiaryInfo.middleInitial || ''
        this.SUFFIX = beneficiaryInfo.suffixName || ''
        this.TITLE = beneficiaryInfo.title
        this.HICN = beneficiaryInfo.medicareId
        this.APPDOB = beneficiaryInfo.dateOfBirth
        this.APPPHONE = beneficiaryInfo.primaryPhone || ''
        this.CELLPHONE = beneficiaryInfo.cellPhone || ''
        this.APPEMAIL = beneficiaryInfo.email
        this.APPGEN = beneficiaryInfo.gender
        this.MEDA = beneficiaryInfo.medicarePartAEffectiveDate
        this.MEDB = beneficiaryInfo.medicarePartBEffectiveDate
        this.APPDT = beneficiaryInfo.applicationDate
        this.EFFDT = beneficiaryInfo.effectiveEnrollmentDate
    }
    get beneficiaryInfo(): BeneficiaryInfo {
        return {
            lastName: this.APPLN,
            firstName: this.APPFN,
            middleInitial: this.APPMI,
            suffixName: this.SUFFIX,
            title: this.TITLE,
            medicareId: this.HICN,
            dateOfBirth: this.APPDOB,
            primaryPhone: this.APPPHONE,
            cellPhone: this.CELLPHONE,
            email: this.APPEMAIL,
            gender: this.APPGEN,
            medicarePartAEffectiveDate: this.MEDA,
            medicarePartBEffectiveDate: this.MEDB,
            applicationDate: this.APPDT,
            effectiveEnrollmentDate: this.EFFDT
        } as BeneficiaryInfo
    }

    set paymentAccount(paymentAccount: PaymentAccount) {
        this.ACCHOLDERNAME = paymentAccount.holderName
        this.EFTTYPE = paymentAccount.type || ''
        this.FININSTNAME = paymentAccount.institution
        this.ROUTINGNB = paymentAccount.routingNumber
        this.ACCOUNTNB = paymentAccount.number
    }
    get paymentAccount(): PaymentAccount {
        return {
            holderName: this.ACCHOLDERNAME,
            type: this.EFTTYPE,
            institution: this.FININSTNAME,
            routingNumber: this.ROUTINGNB,
            number: this.ACCOUNTNB
        } as PaymentAccount
    }

    set otherDrugCoverage(drugCoverage: OtherDrugCoverage) {
        this.OTHCVRGNAME = drugCoverage.planName
        this.COBBIN = drugCoverage.rxBin || ''
        this.COBEFFDT = drugCoverage.effectiveDate
        this.COBTERMDT = drugCoverage.termDate
        this.COBPCN = drugCoverage.rxPcn || ''
        this.OTHCVRGID = drugCoverage.rxId || ''
        this.OTHCVRGGRP = drugCoverage.rxGroup || ''
    }
    get otherDrugCoverage(): OtherDrugCoverage {
        return {
            planName: this.OTHCVRGNAME,
            rxBin: this.COBBIN,
            effectiveDate: this.COBEFFDT,
            termDate: this.COBTERMDT,
            rxPcn: this.COBPCN,
            rxId: this.OTHCVRGID,
            rxGroup: this.OTHCVRGGRP
        } as OtherDrugCoverage
    }

    set notes(note: string) {
        this.NOTES = note
    }
    get notes(): string {
        return this.NOTES
    }

    DISENROLLIND: string = ''
    DISENROLLDATE: string
    DISENROLLNOTICEDT: string
    DISENROLLREASONCD: string = ''
    DISENROLLTYPE: string = ''
    PaperlessSettings: boolean
}
